import { Box, FormControl, FormLabel, ListItem } from "@mui/material";
import { SmartAutoComplete, SmartDatePicker } from "@nodeon/react-components";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ActionType } from "~/api/GeneratedApi";
import { useActionSearchOptions } from "../hooks/useActionSearchOptions";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type TimeAndStateFormTypes = {
  actionExecutionStartDate: Date | null;
  actionExecutionEndDate: Date | null;
  state: ActionType | null;
};

export const timeAndStateFormDefaultValues: TimeAndStateFormTypes = {
  actionExecutionStartDate: null,
  actionExecutionEndDate: null,
  state: null,
};

export const TimeAndStateForm = ({
  isDisabled,
}: SharedFormProps): JSX.Element => {
  const { control } = useFormContext<TimeAndStateFormTypes>();
  const { t } = useTranslation("fairwayReport");
  const { actionDropDown, isLoading } = useActionSearchOptions();
  return (
    <>
      <Box
        sx={{
          display: "flex",

          gap: "10px",
        }}
      >
        <FormControl>
          <FormLabel>{t("fairwayReport:executionDate")}</FormLabel>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
            }}
          >
            <SmartDatePicker<TimeAndStateFormTypes>
              disabled={isDisabled}
              controllerProps={{ control }}
              name="actionExecutionStartDate"
              label={t("vessels:startTime")}
            />
            {/* <Box sx={{ display: "flex", alignItems: "flex-end" }}>
              <Typography variant="h4">-</Typography>
            </Box> */}

            <SmartDatePicker<TimeAndStateFormTypes>
              disabled={isDisabled}
              controllerProps={{ control }}
              name="actionExecutionEndDate"
              label={t("vessels:endTime")}
            />
          </Box>
        </FormControl>
      </Box>
      <SmartAutoComplete<TimeAndStateFormTypes, ActionType, false>
        disabled={isDisabled}
        name="state"
        loading={isLoading}
        label={t("fairwayReport:state")}
        options={actionDropDown?.state ?? []}
        controllerProps={{ control }}
        getOptionLabel={({ codE_NME }) => codE_NME ?? ""}
        isOptionEqualToValue={({ actioN_CDE }, options) =>
          actioN_CDE === options.actioN_CDE
        }
        renderOption={(props, params) => (
          <ListItem {...props} key={`${params.actioN_CDE}-${params.codE_NME}`}>
            {params.codE_NME}
          </ListItem>
        )}

        // renderOption={(props, params) => (
        //   <ListItem
        //     {...props}
        //     key={`${params.actioN_TYPE_CDE}-${params.codE_NME}`}
        //   >
        //     {params.codE_NME}
        //   </ListItem>
        // )}
      />
    </>
  );
};
